<template>
<div class="readable">
  <p>
    <table class="plan_content">
      <thead>
        <tr>
          <th>WeRUNは、ニーズに合わせて長期と短期料金を用意しております。</th>
        </tr>
      </thead>
    </table>
    <h3>長期利用のご利用料金（6ヵ月以上契約）</h3>
    <table class="plan_content">
      <thead>
        <tr>
          <th>Free</th>
          <td class="title">Small</td>
          <th>Basic</th>
          <td class="title">VIP</td>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td bgColor=#f5f7fa class="comment">小人数</td>
          <td class="comment">スモールスタート</td>
          <td bgColor=#f5f7fa class="comment">企業/団体に最適</td>
          <td class="comment">福利厚生の充実</td>
        </tr>
        <tr>
          <td nowrap bgColor=#f5f7fa class="price">無料</td>
          <td nowrap class="price">¥150円</td>          
          <td nowrap bgColor=#f5f7fa class="price">¥300円</td>
          <td nowrap class="price">¥600円</td>
        </tr>
        <tr>
          <td bgColor=#f5f7fa></td>
          <td class="comment">／月／ID</td>
          <td bgColor=#f5f7fa class="comment">／月／ID</td>
          <td class="comment">／月／ID</td>
        </tr>
        <tr>
          <td bgColor=#f5f7fa class="func_list">
            <ul>
              <li>5人までイベント開催</li>
              <li>公開イベントに参加</li>
              <li>無料マイル付き</li>
            </ul>
          </td>
          <td class="func_list">
            <ul>
              <li>歩数ランキング</li>
              <li>距離ランキング</li>
              <li>安心なサポート</li>
            </ul>
          </td>
          <td bgColor=#f5f7fa class="func_list">
            <ul>
              <li>多様なオンラインイベント</li>
              <li>マイルをAmazonギフト券に交換</li>
              <li>専任スタッフによるサポート</li>
              <li>企業ブランディング</li>
            </ul>
          </td>
          <td class="func_list">
            <ul>
              <li>ギフト券交換率3倍に</li>
              <li>OpenAPIでデータ連携</li>
              <li>アプリ内でアイテム販売</li>
            </ul>
          </td>
        </tr>
        <tr>
          <td bgColor=#f5f7fa class="comment">永久に無料です</td>
          <td class="comment"></td>          
          <td bgColor=#f5f7fa class="comment"></td>
          <td class="comment"></td>
        </tr>
      </tbody> 
      <tfoot>
        <tr>
          <td class="comment" colspan="4">例)200人の場合、Basicプラン6か月のご利用料金は36万円です。<br>
          ※1,000人以上の場合はお問い合わせください。</td>
        </tr>
      </tfoot>
    </table>
  </p>

  <p>
    <h3>短期利用の月額ご利用料金（5ヵ月以内契約）</h3>
    <table class="plans">
      <thead>
        <tr>
          <th>登録ID数</th>
          <th>Smallプラン</th>
          <th>Basicプラン</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <th>1~100</th>
          <td>¥40,000</td>
          <td>¥60,000</td>
        </tr>
        <tr>
          <th>101~200</th>
          <td>¥80,000</td>
          <td>¥120,000</td>
        </tr>
        <tr>
          <th>201~300</th>
          <td>¥120,000</td>
          <td>¥180,000</td>
        </tr>
        <tr>
          <th>301~400</th>
          <td>¥160,000</td>
          <td>¥240,000</td>
        </tr>
        <tr>
          <th>401~500</th>
          <td>¥200,000</td>
          <td>¥300,000</td>
        </tr>
        <tr>
          <th>501~1,000</th>
          <td>¥240,000</td>
          <td>¥360,000</td>
        </tr>
        <tr>
          <th>1,001~2,000</th>
          <td>¥320,000</td>
          <td>¥480,000</td>
        </tr>
        <tr>
          <th>2,001~3,000</th>
          <td>¥400,000</td>
          <td>¥600,000</td>
        <tr>
          <th>3,001~5,000</th>
          <td>¥560,000</td>
          <td>¥840,000</td>
        </tr>
        </tr>
        <tr>
          <th>5,001~10,000</th>
          <td>¥800,000</td>
          <td>¥1,200,000</td>
        </tr>
      </tbody>
      <tfoot>
        <tr>
          <td class="comment" colspan="3">例)200人の場合、Basicプラン1か月のご利用料金は12万円です。</td>
        </tr>
      </tfoot>
    </table>
  </p>

  <!--
  <p>
    <h3>月契約のご利用料とボリュームディスカウント（月額）</h3>
    <hr>
    <table class="plans">
      <thead>
        <tr>
          <th>登録ID数</th>
          <th>Basicプラン</th>
          <th>長期契約<br>（6か月～、１IDあたり）</th>
          <th>備考</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <th>Basic<br>(~100 ID)</th>
          <td>¥30,000</td>
          <td>¥300</td>
          <td class="comment">　</td>
        </tr>
        <tr>
          <th>Basic<br>(101~500 ID)</th>
          <td>¥200,000</td>
          <td><s>¥300</s><span class="special-price">¥250</span></td>
          <td class="comment">　</td>
        </tr>
        <tr>
          <th>Basic<br>(501~1000 ID)</th>
          <td>¥250,000</td>
          <td><s>¥300</s><span class="special-price">¥200</span></td>
          <td class="comment">　</td>
        </tr>
        <tr>
          <th>Basic<br>(1001~5000 ID)</th>
          <td>¥550,000</td>
          <td><s>¥300</s><span class="special-price">¥100</span></td>
          <td class="comment">　</td>
        </tr>
        <tr>
          <th>Basic<br>(&gt;5001 ID)</th>
          <td>¥800,000</td>
          <td><s>¥300</s><span class="special-price">¥50</span></td>
          <td class="comment">　</td>
        </tr>
      </tbody>
    </table>
  </p>
  -->
  
  <p>
    <h3>各種オプションサービス</h3>
    <hr>
  ・オリジナルバーチャルルート、データ集計、広告掲載<br>
  ・オンラインイベント企画と運営<br>
  ・教育/非営利団体/公益法人向けプラン<br>
  ・詳細は<a style="text-decoration: none;color: #00b9ff;" href="mailto:business@werunclub.net?subject=WeBandのお問い合わせ">お問い合わせ</a>ください。<br>
  </p>

  <p>
    <table class="plan_content">
      <thead>
        <tr>
          <th>WeRUNは、ウェアラブルデバイスでシームレスなサービスを提供しています。</th>
        </tr>
      </thead>
      <tbody>      
        <tr><td><b><a style="text-decoration: none;color: #00b9ff;" href="https://n49sp.app.goo.gl/3sc" target="_blank">スマートウォッチWeBand 3SC</a></b></td></tr>
        <tr><td class="comment">※WeBandはオプションです。</td></tr>
      </tbody> 
    </table>
  ・安心な<b>１年間メーカー保証</b>が付いています。<br>
  ・専用デバイスだから、<b>ワンタップで簡単データ転送</b>。データ欠損の心配もありません。<br>
  ・ボーナスマイル付き。<b>ギフト券還元率3倍に</b>。使うほどおトク！<br>
  ・新規購入の場合、合計２か月間（お申込み月とその後１か月）の<b>プラン利用料が無料</b>となります。<br>
  ・サブスクリプションプランはあります。<br>
  ・<b>無償貸出</b>は<a href="https://forms.gle/CCuUrfgWeqxvDTWD7" target="_blank">お申込み</a>ください。（トライアル期間中のみ申請可能）
  </p>

  <!-- 
  <p>
    <h3>決済方法</h3>
    <hr>
    銀行振込<br>
    ・銀行名：三井住友銀行<br>
    ・支店名：豊中支店<br>
    ・口　座：普通口座　6847230<br>
    ・名　義：カ）シング<br><br>
    ※恐れ入りますが、振込手数料はお客様のご負担でお願い致します。<br>
    ※導入済みの場合、決済完了後に<span class="highlight-bold">グループ名</span>または<span class="highlight-bold" v-if="clubID>0">グループID: {{ clubID }}</span><span class="highlight-bold"  v-else>グループID</span>をご連絡ください。<br>
  </p>
  -->

  <p>
    <h3>お問い合わせ先</h3>
    <hr>
    E-mail：<a style="text-decoration: none;color: #00b9ff;" href="mailto:business@werunclub.net?subject=件名を入力してください">business@werunclub.net</a><br>
    ※<span class="highlight-bold">グループ名</span>または<span class="highlight-bold" v-if="clubID>0">グループID: {{ clubID }}</span><span class="highlight-bold"  v-else>グループID</span>をご連絡ください。<br>
  </p>

  <p>
    <h3>補足説明</h3>
    <hr>
    1. プラン利用料は毎月1日～末日の単位で計算され、ご利用開始／終了した日付にかかわらず、その月1か月分の費用がかかります。 <br>
    2. 表示価格は、特別な記載のない限り消費税は含まれておりません。 <br>
    3. 内容は予告なく変更される場合がございます。 <br>
  </p>
</div>
</template>

<style lang="scss" scoped>
@import "../../node_modules/hotcss/src/px2rem.scss";
$designWidth : 750;

.readable {
  padding: px2rem(20) px2rem(10);
  font-size: 16px;
  line-height: 1.8em;

  h3 {
    font-size: 16px;
    width: 100%;
    text-align: left;
    margin-bottom: 10px;
  }

  .highlight-bold {
    font-weight: bold;
  }

  .plans {
    width: 100%;
    border-collapse: collapse;
    font-size: 16px;

    td, th {
      border: 1px solid #dee2e6;
      padding: px2rem(10) px2rem(10);
      font-size: 14px;
    }

    th {
      background: #f5f7fa;
    }

    td {
      text-align: right;
    }

    s {
      font-size: 14px;
      color: #666;
    }

    tbody {
      th {
        text-align: left;
      }
    }

    tfoot {
      td {
        text-align: left;
      }
    }
    .special-price {
      font-size: 14px;
      color: green;
      clear: left;
      display:block;
    }
    .comment {
      font-size: 12px;
      color: dimgray;
    }
  }

  .plan_content {
    width: 100%;
    border-collapse: collapse;
    font-size: 16px;

    td, th {
      padding: px2rem(5) px2rem(5);
      font-size: 16px;
    }

    th {
      background: #f5f7fa;
    }

    td {
      text-align: center;
    }

    s {
      font-size: 14px;
      color: #666;
    }

    tbody {
      th {
        text-align: left;
      }
    }

    tfoot {
      td {
        text-align: left;
      }
    }

    .special-price {
      font-size: 14px;
      color: green;
      clear: left;
      display:block;
    }
  
    .price {
      font-size: 20px;
      color: #2E9CD4;
      font-weight: bold; 
    }

    .func_list {
      font-size: 12px;
      text-align: left;
    }

    .comment {
      font-size: 12px;
      color: dimgray;
    }

    .title {
      font-weight: bold; 
    }

    ul {
      padding-left: px2rem(30);
    }

    li {
      padding-left: px2rem(0);
    }
  }
}
</style>

<script>
export default {
  data () {
    return {
      clubID: 0
    }
  },
  created () {
    window.document.title = 'WeRUNの料金プランと価格'
    this.clubID = this.$route.query.club_id || 0
  }
}
</script>


// WEBPACK FOOTER //
// src/pages/VipGuide.vue